import logo from '../assets/logo.png'
import { SiExpress, SiCss3, SiHtml5, SiTailwindcss, SiJavascript, SiReact, SiNodedotjs, SiMongodb, SiSass, SiFirebase, SiSolidity, SiWeb3Dotjs, SiBootstrap, SiPython } from "react-icons/si";
import { LiaExternalLinkAltSolid } from "react-icons/lia";


const OtherProjects = ({ ref, lightMode }) => {
    return (
        <div ref={ref} className={'section ' + (lightMode ? 'light-primary' : 'dark-primary')}>
            <p className="norm-header">Other projects</p>
            <div className="other-works">
                <div className={'o-work ' + (lightMode ? 'light-secondary' : 'dark-secondary')}>
                    <img src={logo} alt="" />
                    <p className="o-work-title">Ogb Admin</p>
                    <p className="work-exp">Admin panel for an online store</p>
                    <div className="work-langs">
                        <SiHtml5 />
                        <SiReact />
                        <SiExpress />
                        <SiFirebase />
                        <SiMongodb />
                        <SiNodedotjs />
                        <SiJavascript />
                    </div>
                    <a href="https://ogbstores.live/login" className="work-link"><LiaExternalLinkAltSolid style={{ fontSize: "1.5rem" }} /> <span></span></a>
                </div>

                <div className={'o-work ' + (lightMode ? 'light-secondary' : 'dark-secondary')}>
                    <img src={logo} alt="" />
                    <p className="o-work-title">Chaotic Swap</p>
                    <p className="work-exp">Connect your crypto wallet and exchange tokens</p>
                    <div className="work-langs">
                        <SiHtml5 />
                        <SiReact />
                        <SiSolidity />
                        <SiWeb3Dotjs />
                        <SiJavascript />
                    </div>
                    <a href="https://chaoticswap.vercel.app/" className="work-link"><LiaExternalLinkAltSolid style={{ fontSize: "1.5rem" }} /> <span></span></a>
                </div>

                <div className={'o-work ' + (lightMode ? 'light-secondary' : 'dark-secondary')}>
                    <img src={logo} alt="" />
                    <p className="o-work-title">Aka's portfolio</p>
                    <p className="work-exp">Personal portfolio website</p>
                    <div className="work-langs">
                        <SiHtml5 />
                        <SiReact />
                        <SiJavascript />
                    </div>
                    <a href="https://adika.vercel.app/" className="work-link"><LiaExternalLinkAltSolid style={{ fontSize: "1.5rem" }} /> <span></span></a>
                </div>
            </div>
        </div>
    )
}

export default OtherProjects
